import { ArrowDownTrayIcon, PhotoIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { isEmpty, isFunction, isString } from "lodash";

export default function ImagePreview({ show, imgPath, imgSource, data, masked = true, onClose, ...props }) {
    const dataFields = [
        { name: "검사일자", id: "inst_dt" },
        { name: "디바이스(모델)", id: "info_model" },
        { name: "사용자명", id: "user_nm" },
        { name: "단계", id: "insp_level" },
        { name: "RGB", id: "insp_rgb" },
        { name: "RGB2", id: "insp_rgb2" },
        { name: "RGB3", id: "insp_rgb3" },
        { name: "LAB", id: "lab" },
        { name: "FP", id: "insp_value" },
        { name: "Y(G)", id: "yg" },
        { name: "Cb", id: "cb" },
        { name: "Cr", id: "cr" },
        { name: "Cb-Cr", id: "distanceCbCr" },
        { name: "RGB거리", id: "distanceRGB" },
        { name: "C", id: "c" },
        { name: "M", id: "m" },
        { name: "Y", id: "y" },
        { name: "K-상수", id: "kval" },
        { name: "K-소수", id: "kconstant" },
        { name: "HSL", id: "hsl" },
        { name: "델타", id: "deltaPrime" },
        { name: "이미지 위치", id: "imgPath" },
    ];

    const handleOnClickDownloadImage = () => {
        const link = document.createElement("a");
        link.href = imgSource;
        link.download = imgPath;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleOnClose = () => {
        if (onClose && isFunction(onClose)) {
            onClose();
        }
    };

    const rgbToCssColor = (inspRgb) => {
        console.log("🚀 ~ rgbToCssColor ~ inspRgb:", inspRgb);
        if (inspRgb && isString(inspRgb)) {
            const splittedRGB = inspRgb.split(",");
            // console.log("🚀 ~ rgbToCssColor ~ splittedRGB:", splittedRGB);
            return `rgb(${splittedRGB[0]}, ${splittedRGB[1]}, ${splittedRGB[2]})`;
        }
    };

    const getDeviceModel = (deviceModel) => {
        if (deviceModel && isString(deviceModel) && !isEmpty(deviceModel)) {
            if (deviceModel.includes("iPhone")) {
                return "iPhone";
            } else {
                return "Android";
            }
        } else {
            return "";
        }
    };

    const maskedUserNm = (name) => {
        // 표의 "마스킹 처리" 토글을 그대로 따른다.
        if (!masked) {
            return name;
        }
        if (name && isString(name) && name.length <= 2) {
            return name;
        }
        // isEmpty 가드가 없으면 빈 문자열에서 "*".repeat(-2) 로 RangeError 가 난다.
        if (isString(name) && !isEmpty(name)) {
            const firstChar = name.charAt(0);
            const lastChar = name.charAt(name.length - 1);
            const maskedSection = "*".repeat(name.length - 2);

            return `${firstChar}${maskedSection}${lastChar}`;
        }
    };

    const createRGBViewer = (val) => {
        return (
            <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                <span>{val}</span>
                <div
                    className="ml-2 rounded-sm"
                    style={{
                        height: 28,
                        width: 28,
                        marginLeft: "0.5rem",
                        borderRadius: "0.5rem",
                        backgroundColor: rgbToCssColor(val),
                    }}
                />
            </div>
        );
    };

    const getFieldValues = (item, imgPath) => {
        switch (item.id) {
            case "insp_rgb":
                return createRGBViewer("221,212,1");
            case "insp_rgb2":
                return createRGBViewer(data[item.id]);
            case "insp_rgb3":
                return createRGBViewer(data[item.id]);
            case "info_model":
                return getDeviceModel(data[item.id]);
            case "user_nm":
                return maskedUserNm(data[item.id]);
            case "imgPath":
                return <span style={{ fontSize: "0.8rem" }}>{imgPath}</span>;
            default:
                return <span>{data[item.id]}</span>;
        }
    };

    return (
        <>
            <div>
                <div
                    style={{
                        marginTop: "1rem",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "flex",
                                height: "3rem",
                                width: "3rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "9999px",
                                backgroundColor: `rgb(222 247 236)`,
                            }}
                        >
                            <PhotoIcon style={{ height: "1.5rem", width: "1.5rem", color: `rgb(5 122 85)` }} aria-hidden="true" />
                        </div>
                        <span
                            style={{
                                marginLeft: "1rem",
                                fontSize: "1rem",
                                fontWeight: "600",
                                lineHeight: "1.5rem",
                                color: `rgb(17 24 39)`,
                            }}
                        >
                            이미지 미리보기
                        </span>
                    </div>
                    <div style={{ display: "flex" }}>
                        <button
                            type="button"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                columnGap: "0.4rem",
                                borderRadius: "0.25rem",
                                backgroundColor: "white",
                                padding: "0.5rem 1rem",
                                fontSize: "0.87rem",
                                color: "black",
                                boxShadow: "#000",
                                cursor: "pointer",
                            }}
                            className="gap-x-1 text-sm"
                            onClick={() => handleOnClickDownloadImage()}
                        >
                            <ArrowDownTrayIcon style={{ height: "1rem", width: "1.5rem", color: `#000` }} aria-hidden="true" />
                            이미지 다운로드
                        </button>
                        <button
                            type="button"
                            style={{
                                display: "inline-flex",
                                marginLeft: "0.5rem",
                                alignItems: "center",
                                columnGap: "0.4rem",
                                borderRadius: "0.25rem",
                                backgroundColor: "white",
                                padding: "0.5rem 1rem",
                                fontSize: "0.87rem",
                                color: "black",
                                boxShadow: "#000",
                                cursor: "pointer",
                            }}
                            className="gap-x-1"
                            onClick={() => handleOnClose()}
                        >
                            <XMarkIcon style={{ height: "1rem", width: "1rem", color: `#000` }} aria-hidden="true" />
                            닫기
                        </button>
                    </div>
                </div>
                <div>
                    <div className="mb-5 px-5" style={{ display: "flex", justifyContent: "space-between", marginTop: "2rem" }}>
                        <div style={{ width: "100%" }}>
                            <span
                                style={{
                                    width: "100%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "1.25rem",
                                    fontWeight: "bold",
                                    color: "black",
                                }}
                            >
                                이미지 상세 정보
                            </span>
                            {imgSource && (
                                <div className="flex items-center justify-center px-6 mb-3" style={{ height: "600px" }}>
                                    <img
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "600px",
                                            borderRadius: "5px",
                                        }}
                                        src={imgSource}
                                        alt="테스트 이미지"
                                    />
                                </div>
                            )}
                            {
                                data &&
                                    dataFields.map((item, index) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
                                                    borderLeft: "1px solid gray",
                                                    borderRight: "1px solid gray",
                                                    borderTop: "1px solid gray",
                                                    borderBottom: dataFields.length - 1 === index ? "1px solid gray" : "none",
                                                    backgroundColor: "#FFF",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        gridColumn: "span 1 / span 1",
                                                        padding: "0.2rem",
                                                        borderRight: "1px solid gray",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "0.7rem",
                                                            fontWeight: "bolder",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {item.name}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        gridColumn: "span 4 / span 4",
                                                        paddingLeft: "0.5rem",
                                                    }}
                                                >
                                                    {getFieldValues(item, imgPath)}
                                                </div>
                                            </div>
                                        );
                                    })
                                // <div
                                //     style={{
                                //         display: "flex",
                                //         alignItems: "center",
                                //         justifyContent: "start",
                                //         margin: "1rem",
                                //     }}
                                // >
                                //     <div
                                //         style={{
                                //             display: "flex",
                                //             width: "100%",
                                //             alignItems: "center",
                                //             justifyContent: "space-between",
                                //         }}
                                //     >
                                //         <label>검사일자</label>
                                //         <label>{data.inst_dt}</label>
                                //     </div>
                                // </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
